import { render, staticRenderFns } from "./EstudiosTabContent.vue?vue&type=template&id=171095ea&scoped=true"
import script from "./EstudiosTabContent.vue?vue&type=script&lang=js"
export * from "./EstudiosTabContent.vue?vue&type=script&lang=js"
import style0 from "./EstudiosTabContent.vue?vue&type=style&index=0&id=171095ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171095ea",
  null
  
)

export default component.exports